import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=a4bf60b8&scoped=true"
import script from "./CategoryDetail.vue?vue&type=script&lang=js"
export * from "./CategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=a4bf60b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bf60b8",
  null
  
)

export default component.exports